import { inject, Injectable } from '@angular/core';
import { Observable, switchMap, throwError } from 'rxjs';

import { Config } from '../models/config.interface';

import { AuthApiService } from './auth-api.service';
import { UserProfile } from './models/user-profile.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private idToken: string | null = null;
  authApiService = inject(AuthApiService);
  
  init(config: Config): Observable<UserProfile | null> {
    return this.authApiService.init(config).pipe(
      switchMap(userProfile => {
        if (userProfile) {
              this.idToken = userProfile.jwtId;
              return [userProfile];
            } else {
              // No user. Abort start of the application and redirect to login
              return throwError(
                () => new Error('Initialization failed: UserProfile is null'),
              );
            }
         })
        )  ;
  }

  getIdToken(): string | null {
    return this.idToken;
  }

  signOut(): Observable<null> {
    return this.authApiService.signOut();
  }



}
